module.exports = __webpack_public_path__ + "img/serviceplanner-test-now-de.875519b3.webp";